import { Route } from 'react-router-dom';

import Home from '../../Home';

const HomeRoutes = () => {
  return (
    <>
      <Route path="home/inicio" element={<Home />} />
    </>
  );
};

export default HomeRoutes;
